import React from 'react';
import memoizeOne from 'memoize-one';
import isDeepEqual from 'lodash.isequal';
import Hotkey from '../lib/Hotkey';
import { AlexaCommon } from '../utils/Common'
import Dropdown from './../assets/ui_assets/controls/Dropdown';
import { LocalizationContext } from 'localization-context';
import { type } from 'os';
import CheckBox from 'assets/ui_assets/controls/CheckBox';
import { resolve } from 'path';

const autoBind = require('auto-bind');


class RZAudioPanel extends React.Component {
  _audioDeviceData = null;

  /**
   *
   * @param {*} props
   * @example
   * @param {object} props.avsWrapper
   * @param {string} props.audioDeviceData.active
   * @param {array} props.audioDeviceData.supported
   * @param {string} props.audioDeviceData.deviceId
   * 
   * @description
   * Initial data is localStorage data if it has, just for displaying for now. 
   * The valid data (synapseData from wpf) will overwrite these data.
   */
  constructor(props) {
    super(props);
    //0-> audioDeviceData 1-> shortcutKey
    this.dataArrivingMarker = [false,false];
    this.state = {
      shortcutKey: localStorage.getItem("audioPanel_shortcutKey") !== null  ? 
                   localStorage.getItem("audioPanel_shortcutKey") : "No Shortcut defined",
      activeDevice: localStorage.getItem("audioPanel_activeDevice") !== null ? 
                   localStorage.getItem("audioPanel_activeDevice") :  (this.props.audioDeviceData
        ? this.props.audioDeviceData.active
        : undefined),
      //Current dropdown will be missing if there is an empty input list.
      optionsList: localStorage.getItem("audioPanel_optionList") !== null ? 
                   localStorage.getItem("audioPanel_optionList") : [""],
      isEnableWakeWord: localStorage.getItem("audioPanel_isEnableWakeWord") !== null ?
                        localStorage.getItem("audioPanel_isEnableWakeWord") !== "undefined" : true,
      isEnableShortCut: localStorage.getItem("audioPanel_isEnableShortCut") !== null ?
                        localStorage.getItem("audioPanel_isEnableShortCut") : true,
      isPageLoading: true,
      isAllowedToUseWakeWord: false,
      isAllowedToUseAudioDeviceDropDown: true
    };
    this._audioDeviceData = this.props.audioDeviceData;
    this.avsWrapper = this.props.avsWrapper;
    autoBind(this);
    //memorization
    /**
     * @see https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#anti-pattern-unconditionally-copying-props-to-state
     */
    this.memoizeUpdateOSDeviceInfoToBE = memoizeOne(
      (deviceLabel, optionsList) =>
        this.storeCurrentAudioDeviceToBE(deviceLabel, optionsList)
    );

    this.memoizePropAudioDeviceData = memoizeOne(
      (audioDeviceDataObj) => this.refreshMediaDevice(),
      isDeepEqual
    )
  }


  /**
   *
   * @param {object} e
   */
  handleError(e) {
    window.avs.setMicDetected(false);
    AlexaCommon.consoleLogDataUIFatalError(
      "Cannot refresh current OS device list for this reason =>",
      e
    );
  }

  /**
   * @event window.rzevent.EventTypes.SHORTCUT_SET
   * @event window.rzevent.EventTypes.DEVICE_UPDATED
   * @event window.rzevent.EventTypes.WAKE_WORD_STATUS_CHANGE
   */
  subscribeEvents() {
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.SHORTCUT_SET,
      "1",
      (shortcut = {}) => this.onShortcutChange(shortcut)
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.DEVICE_UPDATED,
      "1",
      () => this.onDeviceUpdated()
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.WAKE_WORD_STATUS_CHANGE,
      "1",
      (bstatus) => this.onWakeWordIsAllowedStatusChange(bstatus)
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_AUDIO_DEVICE_ENABLE_STATUS,
      "1",
      (bstatus) => this.onAudioDeviceDropDownEnableStatusChange(!bstatus)
    )
  }

  /**
   * @description
   * This method will be called when any USB device in/out
   * It was handled and detected by WPF(C#) event.
   * @throws
   * Current implementation has flaws, need to change. Because WPF event might sent very quickly which faster than
   * WebAPI to make response to update navigator.mediaDevices.enumerateDevices() resources.If we call this.refreshMediaDevice()
   * it navigator.mediaDevices.enumerateDevices() might still contains the unplugged device info.
   * @todo
   * need to figure it out a better way.
   *
   */
  onDeviceUpdated() {
    console.log("device changed in RzAudioPanel.js");
  }

  onAudioDeviceDropDownEnableStatusChange(bStatus){
    this.setState({
      isAllowedToUseAudioDeviceDropDown: bStatus
    },()=>{
      AlexaCommon.consoleLogDataUIImportantInfo("isAllowedToUseAudioDeviceDropDown: ",bStatus);
    })
  }

  onWakeWordIsAllowedStatusChange(bStatus){
     this.setState({
      isAllowedToUseWakeWord: bStatus
     },()=>{
      AlexaCommon.consoleLogDataUIImportantInfo("isAllowedToUseWakeWord: ",bStatus);
     })
  }
  /**
   * @param {string} deviceLabel
   * @description
   * This method only works when curr OS info is different than webservice storage info.
   */
  storeCurrentAudioDeviceToBE(deviceLabel, optionsList) {
    if (typeof this.props.audioDeviceData !== "undefined") {
      let data = this.props.audioDeviceData;
      data.active = deviceLabel;
      window.SynapseMessenger.setToBE("AudioDevice", JSON.stringify(data));
    }
  }

  /**
   * @param {string} shortcut
   * @example wpf6|87
   * @function this.setState(shortcutKey)
   */
  onShortcutChange(shortcut) {
    console.log("this is from wpf" + shortcut);
    let isPageLoading = this.onUpdatePageIsloading(1);
    if (isPageLoading) { AlexaCommon.consoleLogDataUIImportantInfo("audioPanel load synapse data complete",isPageLoading)}
    this.setState({
      shortcutKey: AlexaCommon.getHotKeyTriggerFromKeyCode(shortcut),
      isPageLoading: isPageLoading
    }, ()=>{
       localStorage.setItem("audioPanel_shortcutKey", this.state.shortcutKey);
    });
  }

  /**
   *
   * @param {string} value
   * @function this.setState(activeDevice)
   * @description
   * 1.Update state activeDevice
   * 2.Swap connected stream in avs object.
   * 3.Update web service storage.
   */
  onDeviceOptionChange(value) {
    let deviceLabel = this.getActiveDeviceLabel(value);
    if (typeof deviceLabel !== "undefined") {
      this.setState({ activeDevice: deviceLabel }, () => {
  
        //[WEB SERVICE STORAGE]
        this.memoizeUpdateOSDeviceInfoToBE(deviceLabel, this.state.optionsList);
        
    if (window.location.href.indexOf("?page=settings") < 0) { return; }
        window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_IS_ALLOW_WAKE_WORD_STATUS_CHANGE);
      });
    }
  }

  /**
   * @emits window.rzevent.EventTypes.REQUEST_ENABLE_WAKEWORD_STATUS_CHANGE
   * @function this.setState(isEnableWakeWord)
   */
  onIsEnableWakeWordCheckBoxChange(){
    this.setState({
      isEnableWakeWord: !this.state.isEnableWakeWord
    },()=>{
      window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_ENABLE_WAKEWORD_STATUS_CHANGE,this.state.isEnableWakeWord);
      AlexaCommon.consoleLogDataUIImportantInfo("Is Enable WakeWord status changed", this.state.isEnableWakeWord);
      localStorage.setItem("audioPanel_isEnableWakeWord", this.state.isEnableWakeWord);
    });
  }

    /**
   * @emits window.rzevent.EventTypes.REQUEST_ENABLE_SHORTCUT_STATUS_CHANGE
   * @function this.setState(isEnableWakeWord)
   * @description
   */
  onIsEnableShortCutCheckBoxChange(){
    this.setState({
      isEnableShortCut: !this.state.isEnableShortCut
    },()=>{
      window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_ENABLE_SHORTCUT_STATUS_CHANGE,this.state.isEnableShortCut);
      AlexaCommon.consoleLogDataUIImportantInfo("Is Enable ShortCut status changed", this.state.isEnableShortCut);
      localStorage.setItem("audioPanel_isEnableShortCut", this.state.isEnableShortCut);
    });
  }

  /**
   * @param {Number} index
   * @param {Array} this.state.optionsList
   * @description
   * Find the active device name(it's called label in WEBAPI) from option list by index.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaDeviceInfo
   * @returns {string} device full name which may contains etc "(1520:30)"
   */
  getActiveDeviceLabel(index) {
    if (typeof index === "undefined") {
      return;
    }
    let targetOption = this.state.optionsList[index];
    return targetOption;
  }


  /**
   * @description
   * Get current OS device as list.
   * @param {object} this.props.audioDeviceData
   * @method this.handleError
   */
  refreshMediaDevice() {
    //Get mediaDevices
    // navigator.mediaDevices.enumerateDevices()
    //     .then((deviceInfos) => this.getDevices(deviceInfos, this.props.audioDeviceData))
    //     .catch(this.handleError);
    return new Promise((resolve, reject)=>{
      if (typeof this.props.audioDeviceData === "undefined") {
        return reject();
      }
      if (typeof this.props.audioDeviceData.supported === "undefined") {
        return reject();
      }
      try {
        let optionsList = this.props.audioDeviceData.supported.map(
          (item, index) => {
            return item;
          }
        );
        AlexaCommon.consoleLogDataUIImportantInfo("UI received audio device list from webservice.",optionsList);
        let isPageLoading = this.onUpdatePageIsloading(0);
        if (isPageLoading) { AlexaCommon.consoleLogDataUIImportantInfo("audioPanel load synapse data complete",isPageLoading)}
        this.setState({
          optionsList: optionsList,
          activeDevice: this.props.audioDeviceData.active,
          isPageLoading: isPageLoading
        },()=> {
           localStorage.setItem("audioPanel_optionsList", this.state.optionsList);
           localStorage.setItem("audioPanel_activeDevice", this.state.activeDevice);
           resolve();
        });
      }catch{
        reject();
      }
     
    });
   
  }

  onUpdatePageIsloading(dataArrivingMarkerIndex){
    let isPageStillLoading = true; 
    if (dataArrivingMarkerIndex < 2
      && dataArrivingMarkerIndex >= 0){
        isPageStillLoading = false;
        this.dataArrivingMarker[dataArrivingMarkerIndex] = true;
        for (let i = 0 ; i < this.dataArrivingMarker.length; i++){
            if (this.dataArrivingMarker[i] === false){ 
              isPageStillLoading = true;
              break;
            }
        }
      }
    return isPageStillLoading;
  }

  componentDidUpdate(prevProps, prevState) {
    /**
     * @descirption
     * Anti-pattern
     * @see https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#anti-pattern-unconditionally-copying-props-to-state
     */
    if (typeof this.props.audioDeviceData === 'undefined') {
      return;
    }

    this.memoizePropAudioDeviceData(this.props.audioDeviceData);
    // if (typeof prevProps.audioDeviceData === 'undefined'){
    //   this.refreshMediaDevice()
    //   .then(()=>{
    //     this.swapDefaultMedia();
    //   })
    //   .catch(()=>{
    //     AlexaCommon.consoleLogDataUIImportantInfo("Audio Device List is not ready yet, waiting wpf to pass");
    //   });
    // }else{

    // }
    // else if (this.props.audioDeviceData.active !== prevProps.audioDeviceData.active ||
    //   this.props.audioDeviceData.supported.length !== prevProps.audioDeviceData.supported.length) {
    //     this.refreshMediaDevice()
    //     .then(()=>{
    //       this.swapDefaultMedia();
    //     })
    //     .catch(()=>{
    //       AlexaCommon.consoleLogDataUIImportantInfo("Audio Device List is not ready yet, waiting wpf to pass");
    //     });
       
    // }
  }
  /**
   * @description
   * (sequence is matter)
   * 1.Subscribe event
   * 2.Let WPF send down current short cut from the host.
   * 3.Refresh current OS media input device list.
   */
  componentDidMount() {
    this.subscribeEvents();
    window.SynapseMessenger.getShortcut();
    if (window.location.href.indexOf("?page=settings") < 0) { return; }
    window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_IS_ALLOW_WAKE_WORD_STATUS_CHANGE);
   
  }
  /**
   * @method
   * getActiveDeviceIdIndex() -> this.state.activeDevice
   * this.onDeviceOptionChange
   * @param
   * this.state.optionsList
   * this.state.shortcutKey
   *  { disabled={!this.props.alexaStatus || !this.state.isAllowedToUseAudioDeviceDropDown} }
   *  || !this.state.isAllowedToUseWakeWord
   */
  render() {
    let dropDownIndex = 0;
    let isPanelDisabledClassName =
      typeof this.props.alexaStatus !== "undefined"
        ? this.props.alexaStatus
          ? "alexa-not-disabled"
          : "alexa-disabled"
        : "alexa-not-disabled";

    let isAllowToUseWakeWordStyleString = this.state.isAllowedToUseWakeWord ? "block" : "none";

    let dropDownList = [];
    if (typeof this.state.optionsList !== "undefined") {
      dropDownList = this.state.optionsList.map((item, index) => {
        if (item === this.state.activeDevice) {
          dropDownIndex = index;
        }
        let newItem = {};
        newItem.name = item;
        newItem.content = item;
        return newItem;
      });
    }

    AlexaCommon.consoleLogDataUIImportantInfo("Audio device list loaded in dropdown component", JSON.stringify(dropDownList));

    let hotKeyContent = <Hotkey isEnabled={this.state.isEnableShortCut} shortcutKey={this.state.shortcutKey} />;
    return (
      <LocalizationContext.Consumer>
        {values => (
          <div
            className={`settings-container-1 ${isPanelDisabledClassName}`}
            style={{ paddingTop: "10px" }}
          >
            <div className="settings-wrapper-1">
              <div className="settings-title alexa-none">{values.audio}</div>
              <div className="audio-hotkey">
                <div className="settings-subcontent settings-subtitle" style={{textTransform: 'uppercase'}}>
                  {values.activateShortcut}
                </div>
                <div className="settings-subcontent">
                  <div className="settings-subtitle settings-subcontent" style={{display: isAllowToUseWakeWordStyleString}}>
                   
                    <CheckBox
                      id="isEnableWakeWord"
                      disabled={!this.props.alexaStatus} 
                      active={this.state.isEnableWakeWord}
                      onCheck={this.onIsEnableWakeWordCheckBoxChange}
                      name={values.isEnableWakeWord}
                    />
                  </div>
                  <div className="settings-subtitle">
                    <CheckBox
                      id="isEnableShortKey"
                      disabled={!this.props.alexaStatus}
                      active={this.state.isEnableShortCut}
                      onCheck={this.onIsEnableShortCutCheckBoxChange}
                      name={values.isEnableShortCut}
                    />
                  </div>
                </div>
                <div className="settings-subcontent audio-short-cut">
                 {hotKeyContent}
                </div>
              </div>
              <div
                className="audio-input-device"
                style={{ paddingTop: "10px" }}
              >
                <div className="settings-subcontent settings-subtitle" style={{textTransform: 'uppercase'}}>
                  {values.inputDevice}
                </div>
                <div className="settings-subcontent audio-device-selection">
                  <Dropdown
                    dataSet={dropDownList}
                    name="micList"
                    selectOption={this.onDeviceOptionChange}
                    value={dropDownIndex}
                    disabled={!this.props.alexaStatus || !this.state.isAllowedToUseAudioDeviceDropDown}
                   
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }
}
export default RZAudioPanel;
